import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

const Navigation = () => {
  const navigate = useNavigate()
  const { user } = useAuth()

  return (
    <div className='barra-menus'>
      <button className='menu-btn' onClick={() => navigate('/')}>
        Inicio
      </button>
      <button className='menu-btn' onClick={() => navigate('/comprar')}>
        Comprar
      </button>
      <button className='menu-btn' onClick={() => navigate('/alquilar')}>
        Alquilar
      </button>

      {user && (
        <button className='menu-btn add-vehicle-btn' onClick={() => navigate('/add-vehicle')} title='Añadir vehículo'>
          +
        </button>
      )}
    </div>
  )
}

export default Navigation
